const ALIGN_PRINT_SKIP_KEYS = new Set(['paginate', 'goalOffset', 'goalLimit', '_timestamp', 'refsrc']);

function forEachAlignPrintParam(params, onEntry) {
  if (!params || typeof params !== 'object') {
    return;
  }
  Object.keys(params).forEach((key) => {
    if (ALIGN_PRINT_SKIP_KEYS.has(key)) {
      return;
    }
    const v = params[key];
    if (v === undefined || v === null || v === '') {
      return;
    }
    if (key === 'customFields') {
      const s = typeof v === 'string' ? v : JSON.stringify(v);
      if (s && s !== '{}' && s !== '[]') {
        onEntry(key, s);
      }
      return;
    }
    if (Array.isArray(v)) {
      v.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          onEntry(`${key}[]`, item);
        }
      });
      return;
    }
    if (typeof v === 'object') {
      onEntry(key, JSON.stringify(v));
      return;
    }
    onEntry(key, String(v));
  });
}

/**
 * Same key/value rules as {@link buildGoalAlignPrintQueryString}, as a flat object for POST (e.g. goal/sendAlignGoal).
 * @param {Record<string, unknown>} params
 * @returns {Record<string, unknown>}
 */
export function pickGoalAlignPrintParams(params) {
  const out = {};
  forEachAlignPrintParam(params, (key, value) => {
    if (key.endsWith('[]')) {
      const base = key.slice(0, -2);
      if (!Array.isArray(out[base])) {
        out[base] = [];
      }
      out[base].push(value);
    } else {
      out[key] = value;
    }
  });
  return out;
}

/**
 * Serialize alignment filter params for goal/goalAlignPrint (GET).
 * @param {Record<string, unknown>} params
 * @returns {string} query string without leading ?
 */
export function buildGoalAlignPrintQueryString(params) {
  const usp = new URLSearchParams();
  forEachAlignPrintParam(params, (key, value) => {
    usp.append(key, value);
  });
  return usp.toString();
}
